import { useState } from "react";
import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import Content from "../Modulos/Prossmap/Home/Content";
import ModalNovoProssmap from "../Modulos/Prossmap/Home/ModalNovoProssmap";
import ModalGerenciarTipos from "../Modulos/Prossmap/Home/ModalGerenciarTipos";
import { useModal } from "../contexts/ModalContext";

const Prossmap = () => {

    const { openModal, closeModal, isModalOpen } = useModal();
    const [listRefreshKey, setListRefreshKey] = useState(0);

    const openSidebar = () => openModal("prossmapSidebar");

    const openNovoProssmap = () => {
        closeModal();
        openModal("prossmapNovo");
    };

    const openGerenciarTipos = () => {
        closeModal();
        openModal("prossmapTipos");
    };

    return (
        <>
            <NavBar
                title="PROSSMAP"
                goBackOnePage
                setSideBar={openSidebar}
            />
            <GenericBody>
                <Content refreshKey={listRefreshKey} />
            </GenericBody>

            {isModalOpen("prossmapSidebar") && (
                <Overlay state changeContent={closeModal}>
                    <SideMenu>
                        <SideMenuBtn button="NOVO PROSSMAP" clickFunc={openNovoProssmap} />
                        <SideMenuBtn button="GERENCIAR TIPOS" clickFunc={openGerenciarTipos} />
                    </SideMenu>
                </Overlay>
            )}

            {isModalOpen("prossmapNovo") && (
                <ModalNovoProssmap onGenerated={() => setListRefreshKey((k) => k + 1)} />
            )}

            {isModalOpen("prossmapTipos") && <ModalGerenciarTipos />}
        </>
    );
};

export default Prossmap;
